'use client'

import { useEffect, useRef, useState, type FormEvent } from 'react'

import { useTranslation } from '@/hooks/client/use-translation'

type SubmissionState = { status: 'idle' | 'submitting' | 'success' } | { status: 'error'; message: string }

export const usePartnershipForm = () => {
  const { t } = useTranslation()
  const [state, setState] = useState<SubmissionState>({ status: 'idle' })
  const loadedAt = useRef<number | null>(null)

  useEffect(() => {
    loadedAt.current = Date.now()
  }, [])

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    if (state.status === 'submitting') {
      return
    }
    const data = new FormData(event.currentTarget)
    setState({ status: 'submitting' })
    try {
      const response = await fetch('/api/contact-submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          inquiryType: 'partnership',
          firstName: data.get('firstName'),
          company: data.get('company'),
          email: data.get('email'),
          message: data.get('message'),
          website: data.get('website'),
          timeElapsed: Date.now() - (loadedAt.current ?? Date.now()),
        }),
      })
      const result: { error?: boolean } = await response.json()
      if (!response.ok || result.error) {
        throw new Error('contact_submission_failed')
      }
      setState({ status: 'success' })
    } catch {
      setState({
        status: 'error',
        message: t(
          'mediaKit.contact.formError',
          'Your message couldn’t be sent. Please try again or email Tony directly.'
        ),
      })
    }
  }

  return { state, handleSubmit }
}
